import { render } from "./H5ReportDetail.vue?vue&type=template&id=ec60834a&scoped=true"
import script from "./H5ReportDetail.vue?vue&type=script&lang=js"
export * from "./H5ReportDetail.vue?vue&type=script&lang=js"

import "./H5ReportDetail.vue?vue&type=style&index=0&id=ec60834a&scoped=true&lang=css"

import exportComponent from "C:\\Work\\huabiao-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec60834a"]])

export default __exports__